import React from 'react';

export default function SeancesForm({ formData, handleChange }) {
  return (
    <div className="subform" translate="no">
      <h2 className="text-center font-bold text-l border-2 border-blue-500 rounded-md p-4 mb-6">Séances</h2>
      <label>Organisme :</label>
      <input type="text" className="form-control mb-2" name="organismeSeance" value={formData.organismeSeance} onChange={handleChange}/>
      <label>Lieu de la séance / réunion :</label>
      <input type="text" className="form-control mb-2" name="lieuSeance" value={formData.lieuSeance} onChange={handleChange}/>
      
      <label>Ordre du jour de la séance / réunion :</label>
      <textarea className="form-control mb-2" rows="5" cols="40" name="reunionSeance" value={formData.reunionSeance} onChange={handleChange}/>
      <label>Date :</label>
      <input type="date" className="form-control mb-2" name="dateSeance" value={formData.dateSeance} onChange={handleChange}/>
      <label>Durée (en heure) :</label>
      <input type="text" className="form-control" name="HeureSeance" value={formData.HeureSeance} onChange={handleChange}/> 
      <label>Nombre de participants CEA :</label>
      <input type="text" className="form-control" name="participantCea" value={formData.participantCea} onChange={handleChange}/> 
      <label>Résumé/remarques particulières :</label>
      <textarea className="form-control" rows="5" cols="40" placeholder="(expliquez en 2-3 lignes chaque point abordé) " name="observationSeance" value={formData.observationSeance} onChange={handleChange}/> 
    
    </div>
  );
}
